import script from "./RegistrationView.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationView.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationView.vue?vue&type=style&index=0&id=a8266bce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8266bce"]])

export default __exports__